
import { holidayType } from 'json/lab-order'
export let filterLabels = [
  {
    label: '年份',
    type: 'select',
    clearable: true,
    value: 'year', // 需返回数据的字段名
    options: getYears()
  },
  {
    label: '月份',
    type: 'select',
    clearable: true,
    value: 'month', // 需返回数据的字段名
    options: getMonths()
  },
  {
    label: '类型',
    type: 'select',
    clearable: true,
    value: 'holidayTypes', // 需返回数据的字段名
    options: holidayType
  }
]
function getYears () {
  var tYear = new Date().getFullYear()
  let years = [tYear - 1, tYear, tYear + 1]
  return years.map(e => {
    return {
      label: e,
      value: e
    }
  })
}
function getMonths () {
  // let zhMonth = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二']
  return new Array(12).join(',').split(',').map((e, i) => {
    return {
      // label: `${zhMonth[i]}月`,
      // value: `${zhMonth[i]}月`
      label: `${i + 1}月`,
      value: i + 1
    }
  })
}
